<dx-button type="default" stylingMode="contained" [disabled]="!allowAimsSubmit" class="btn w-100" icon="fal fa-cow"
    [text]="caption" (click)="executeAimsRequest()">
</dx-button>